import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.observer = new IntersectionObserver(this.intersectionHandler, this.intersectionOptions)
  }

  connect() {
    this.observe()
  }

  disconnect() {
    this.unobserve()
  }

  observe() {
    this.observer.observe(this.element)
  }

  unobserve() {
    this.observer.unobserve(this.element)
  }

  intersectionHandler() {}

  get intersectionOptions() {
    return {
      rootMargin: `0px 0px ${window.innerHeight}px`,
    }
  }
}
